import Vue from 'vue';
import Vuex from 'vuex'
import {bus} from './bus';
import i18n from './i18n';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        token: null,
        customerCustomFields: [],
        roles: [],
        oppCustomFields: [],
        opportunityStatus: [],
        customerStatus: [],
        phoneStatus: 'disconnected',
        phoneIdle: false,
        inCall: false,
        videoCallEnabled: false,
        callerNumber: '',
        inApp: false,
        hasSocialNetworkAccount: false
    },
    mutations: {
        user(state, user) {
            state.user = user;
            if (user) {
                i18n.locale = user.language;
                Vue.prototype.$service.defaults.headers.common['Accept-Language'] = i18n.locale;
                Vue.prototype.$bgService.defaults.headers.common['Accept-Language'] = i18n.locale;
                setTimeout(() => {
                    const Tawk_API = Tawk_API || window.Tawk_API || null;
                    if (Tawk_API && user) {
                        Tawk_API.setAttributes({
                            'name': `${user.name} (${user.ext}@${user.client.domain})`,
                            'email': `${user.email}`,
                            'hash': user._id
                        }, function () {
                        });
                    }
                }, 3000);
            }
        },
        token(state, token) {
            state.token = token;
            Vue.prototype.$service.defaults.headers.common['token'] = token;
            Vue.prototype.$bgService.defaults.headers.common['token'] = token;
        },
        customerCustomFields(state, customFields) {
            state.customerCustomFields = customFields;
        },
        roles(state, roles) {
            state.roles = roles;
        },
        phoneStatus(state, status) {
            state.phoneStatus = status;
        },
        phoneIdle(state, idle) {
            state.phoneIdle = idle;
        },
        inCall(state, inCall) {
            state.inCall = inCall;
        },
        videoCallEnabled(state, enabled) {
            state.videoCallEnabled = enabled;
        },
        callerNumber(state, number) {
            state.callerNumber = number;
        },
        opportunityStatus(state, status) {
            state.opportunityStatus = status;
        },
        inApp(state, inApp) {
            state.inApp = inApp;
        },
        hasSocialNetworkAccount(state, hasSocialNetworkAccount) {
            state.hasSocialNetworkAccount = hasSocialNetworkAccount;
        },
    },
    actions: {
        login({commit}, data) {
            localStorage.setItem('token', data.token);
            commit('token', data.token);
            return Vue.prototype.$bgService.get('/profile').then(response => {
                commit('user', response.data);
                bus.$emit('initSocket');
                bus.$emit('loadCustomFields');
                bus.$emit('loadCustomStatus');
                bus.$emit('getRoles');
            })
        },
        logout({commit}) {
            return Vue.prototype.$bgService.post('/auth/logout', {token: this.state.token}).then(() => {
                localStorage.removeItem('token');
                commit('user', null);
                commit('token', null);
                bus.$emit('closeSocket');
                bus.$emit('disconnectPhone');
            });
        }
    }
})
